import { messstelle, kenngroesse } from './../../../utils/apiTypes';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { kenngroesseGruppeUwPqIndex, pqIndexResult } from "./pqIndexTypes";
import { postJsonWithAuth } from "../../../utils/api";
import { logError } from "../../../utils/utils";
import { errorHandler } from '../../../utils/errorHandling';

const initialState: kenngroesseGruppeUwPqIndex 
  = {

    kenngroesseListe: [],
    uwKenngroesse:[],
    uw_MinKenngroesse: [],
    uw_MinUW:[],
    minUwKenngroesseAll: 10,
    loadingUwKenngroesse: false,
}

const kenngroesseGruppeUwPqIndexSlice = createSlice({
  name: "kenngroesseGruppeUwPqIndex",
  initialState,
  reducers: 
  {
    setKenngroesseListe: (state, action:PayloadAction<string[]>) => {
      state.kenngroesseListe= action.payload;
    },
    setUWMinKenngroesseListe: (state, action:PayloadAction<number>) => {
      state.uw_MinKenngroesse.push(action.payload);
    },
    emptyUWMinKenngroesseListe: (state) => {
      state.uw_MinKenngroesse= [];
    },
    setUWMinUWListe: (state, action:PayloadAction<number>) => {
        state.uw_MinUW.push(action.payload);
    },
    emptyUWMinUWListe: (state) => {
        state.uw_MinUW= [];
    },
    setMinUWKenngroesseAll: (state, action:PayloadAction<number>) => {
      state.minUwKenngroesseAll = action.payload;
    },
    setUwKenngroesse: (state,  action:PayloadAction<Array<Array<pqIndexResult>>>) => {
      state.uwKenngroesse = action.payload;
    },
    setLoadingUwKenngroesse: (state, action:PayloadAction<boolean>) => {
      state.loadingUwKenngroesse = action.payload;
    },
  }
});

export const selectUWKenngroesseListe = (state: RootState): string[] => state.kenngroesseGruppeUwPqIndex.kenngroesseListe;
export const selectUWMinKenngroesseListe = (state: RootState): number[] => state.kenngroesseGruppeUwPqIndex.uw_MinKenngroesse;
export const selectUwMinUwListe = (state: RootState): number[] => state.kenngroesseGruppeUwPqIndex.uw_MinUW;
export const selectUWMinKenngroesseAll = (state: RootState): number => state.kenngroesseGruppeUwPqIndex.minUwKenngroesseAll;
export const selectUwKenngroesse = (state: RootState): pqIndexResult[][] => state.kenngroesseGruppeUwPqIndex.uwKenngroesse;
export const selectLoadingUwKenngroesse = (state: RootState): boolean => state.kenngroesseGruppeUwPqIndex.loadingUwKenngroesse;

export const getUwKenngroesse = 
    (messstelleParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, pqIndexMinParam: number, pqIndexMaxParam: number, grenzwertsatz: string, grupByUWParam: boolean, groupByKenngroessenkategorieParam:boolean) => (
      dispatch: AppDispatch): void => {
  
  const body = {
    start: startParam,
    end: endeParam,
    kenngroessen: kenngroesseParam,
    messstellen: messstelleParam,
    pqIndexMin: pqIndexMinParam,
    pqIndexMax: pqIndexMaxParam,
    grenzwertsatzName:grenzwertsatz
  }
  
  dispatch(setLoadingUwKenngroesse(true))
  postJsonWithAuth("PQINDEXMESSSTELLEKENNGROESSE", {groupByUw:grupByUWParam, groupByKenngroessenkategorie:groupByKenngroessenkategorieParam }, body)
    .then((response: Array<Array<pqIndexResult>>) => {
      dispatch(emptyUWMinKenngroesseListe());
      dispatch(emptyUWMinUWListe());
      dispatch(setUwKenngroesse(response));
      const kenngroesseList : Array<string> = [];
      let tempMinUwAll = 10;
      let tempMinKenngroesseAll = 10;

      response.forEach( rows => {
        let tempMin = rows[0].value===null || rows[0].value===undefined ? 10 : rows[0].value;
        rows.forEach(row =>{
          kenngroesseList.push(row.col)
          if(row.value !== null && row.value !==undefined){
            if(tempMin > row.value){
              tempMin = row.value
            }
          }
        })
        dispatch(setUWMinUWListe(tempMin))
        if(tempMin !== null && tempMin !==undefined){
          if(tempMinUwAll > tempMin ){
            tempMinUwAll = tempMin;
          }
        }
      })

      kenngroesseList.sort((a,b) => a.localeCompare(b))
      const filterdKenngroesseList : Array<string> =kenngroesseList.filter(function(elem, pos){
        return kenngroesseList.indexOf(elem)==pos;
      })

      filterdKenngroesseList.forEach(kenngroesseElem =>{
        const initData = response[0][0];
        let tempMin = 11;
        if( kenngroesseElem == initData.col ){
          tempMin = initData.value;
        }
        response.forEach(rows => {
          rows.forEach(row => {
            if( kenngroesseElem == row.col ){
              if(row.value !== null && row.value !==undefined){
                if(tempMin > row.value){
                  tempMin = row.value
                }
              }
            }
          })
        })
        dispatch(setUWMinKenngroesseListe(tempMin));
        if(tempMin !== null && tempMin !==undefined){
          if(tempMinKenngroesseAll > tempMin ){
            tempMinKenngroesseAll = tempMin;
          }
        }
      })

      dispatch(setKenngroesseListe(filterdKenngroesseList));
      dispatch(setMinUWKenngroesseAll(tempMinUwAll < tempMinKenngroesseAll ? tempMinUwAll : tempMinKenngroesseAll))

    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setLoadingUwKenngroesse(false)));
};

export const {
    setKenngroesseListe,
    setUwKenngroesse,
    setUWMinKenngroesseListe,
    setMinUWKenngroesseAll,
    emptyUWMinKenngroesseListe,
    setUWMinUWListe,
    emptyUWMinUWListe,
    setLoadingUwKenngroesse,
} = kenngroesseGruppeUwPqIndexSlice.actions;

export default kenngroesseGruppeUwPqIndexSlice.reducer;